




import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ReadingTask4 extends Vue {}
